export const allMediaPresets = ['small', 'medium', 'original'] as const

export type MediaPreset = typeof allMediaPresets[number]
